import * as React from 'react';
export const GHSvg = React.forwardRef(function GHSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M1.994 2A1.992 1.992 0 0 0 0 4v2h16V4c0-1.105-.895-2-1.994-2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 10V6h1v4h-1ZM0 6h1v4H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 10v2c0 1.105.895 2 1.994 2h12.012A1.992 1.992 0 0 0 16 12v-2H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        fillRule: 'nonzero',
        d: 'm10.296 7.167-1.458.003a.202.202 0 0 1-.193-.14l-.452-1.388a.202.202 0 0 0-.386 0l-.45 1.387a.202.202 0 0 1-.193.14h-1.46a.202.202 0 0 0-.118.368l1.18.857a.202.202 0 0 1 .073.227l-.45 1.388a.202.202 0 0 0 .312.227l1.18-.792a.202.202 0 0 1 .239 0l1.18.792a.202.202 0 0 0 .313-.227L9.161 8.62a.202.202 0 0 1 .074-.227l1.18-.857a.205.205 0 0 0-.12-.37Z',
      }),
    ),
  );
});
GHSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GH = {
  category: 'flag',
  colorable: false,
  name: 'GH',
  svg: GHSvg,
};
